<style scoped>
.answerItem {
  width: 50%;
  height: 2.875rem;
  display: inline-table;
  background-color: #7e7885;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  text-transform: uppercase;
  text-align: center;
  color: #fff;
  border-bottom: 0.0625rem solid #fff;
  margin: 0.25rem 1.875rem;
}

.answerItem:hover {
  background-color: #333333;
}

.answersItemsWrapper {
  width: 100%;
  padding: 0 2.25rem;
  display: flex;
  justify-content: center;
  margin: 1.875rem 0 1.25rem 0;
}

h2 {
  font-size: 1.5rem;
  font-weight: 500;
  text-align: center;
  color: #333333;
  text-transform: none;
  margin-top: 2rem;
}

h3 {
  font-size: 0.875rem;
  font-weight: 500;
  text-align: center;
  color: #7e7885;
  padding: 0.5625rem 0 0 0;
  text-transform: none;
}
.content_asset::v-deep * {
    max-width: 100%;
    max-height: 100%;
}

@media (max-width: 576px) {
    .answerItem {
    width: 100%;
    margin: 0.25rem 0;
  }
  .answersItemsWrapper {
    display: block;
    padding: 0;
  }

  h2 {
    font-size: 1.2rem;
  }
}

</style>
<template>
    <div id="modal-template">
        <modal>
            <div slot="header">
                <h2>{{ question.title }}</h2>
                <h3>{{ question.subTitle }}</h3>
            </div>
            <div slot="body">
                <div
                    class="content_asset"
                    v-html="contentAsset"
                />
                <div class="answersItemsWrapper">
                    <div
                        v-for="answer in this.answers"
                        :key="answer.id"
                        class="answerItem"
                        :title="answer.text"
                        v-on:click.prevent="selectAnswer(answer.id); submitQuestion();"
                    >
                        {{ answer.title }}
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import { forIn } from 'lodash';
import ModalTemplate from '../modalTemplate.vue';

export default {
    name: 'Q9Template',
    components: {
        modal: ModalTemplate
    },
    data() {
        return {
            localStateAnswers: {}
        };
    },
    computed: {
        question: function () {
            document.documentElement.style.overflow = 'hidden';
            return this.$store.state.questionData;
        },
        answers: function () {
            return this.$store.state.questionData.answers;
        },
        quizData: function () {
            return this.$store.state.quizData;
        },
        contentAsset: function () {
            return this.$store.state.contentAsset;
        }
    },
    methods: {
        selectAnswer: function (aid) {
            this.$store.commit('setAnswer', aid);
        },
        submitQuestion: function () {
            var answers = [];

            forIn(this.question.answers, function (answer) {
                if (answer.selected === true) {
                    answers.push(answer.id);
                }
            });

            let data = {
                quizid: this.quizData.quizid,
                qid: this.question.id,
                aid: answers
            };
            this.$store.dispatch('submitQuestion', data);
            document.documentElement.style.overflow = 'auto';
        }
    }
};

</script>
